import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

// Metas de gasto por categoria, guardadas em percentual sobre a receita
// recebida no período. Formato: { categoryId, targetPercentage }.
export function useExpenseGoals() {
  const navigate = useNavigate();

  const [goals, setGoals] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGoals = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/financial/goals', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setGoals(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const saveGoals = useCallback(
    (goalsToSave) =>
      quarkusApi.post('/financial/goals', goalsToSave, {
        headers: { Authorization: sessionStorage.getItem('token') },
      }),
    [],
  );

  useEffect(() => {
    fetchGoals();
  }, [fetchGoals]);

  return { goals, isLoading, error, refetch: fetchGoals, saveGoals };
}
